import React, { useState } from "react";
import TogglerBody from "../../TogglerBody";
import InputCheckBoxUser from "../../InputCheckBoxUser";
import ChooseActionTamplate from "../../actionTamplate/ChooseActionTamplate";
import "./statusTamplate.scss";
import TipsTamplate from "../../TipsTamplate";
import SquareIcon from "../../SquareIcon/SquareIcon";
import {statusActions} from '../../../../constants/common'

const StatusTamplate = ({ data }) => {
  const [isOnMonitor, setIsOnMonitor] = useState(data?.data?.enabled);
  const [isOnPunish, setIsOnPunish] = useState(data?.data?.applyPunishment);
  const [isOnRuleset, setIsOnRuleset] = useState(data?.data?.useRuleset);
  const [currentAction, setCurrentAction] = useState(data?.data?.punishment || "Kick");  
  const [repeated, setRepeated] = useState({ name: "repeated", text: "Repeated Text", value: data?.data?.repeated || false });
  const [zalgo, setZalgo] = useState({ name: "zalgo", text: "Z̴̞͝a̵̞̐l̴̘̏g̵̘̈́o̴̻͆  Text", value: data?.data?.zalgo || false });
  const [external, setExternal] = useState({ name: "external", text: "External Links", value: data?.data?.external || false });
  const [invites, setInvites] = useState({ name: "invites", text: "Server Invites", value: data?.data?.invites || false });
  const [files, setFiles] = useState({ name: "files", text: "Files", value: data?.data?.files || false });

  return (
    <div className="status_block_wrap">
      <div className="status_block_wrap_bg"></div>
      <SquareIcon
        squareFirstClassname={"first_square_bg_blue"}
        squareSecondClassname={"second_square_bg_blue"}
        imgSrc={"/img/StatusBlockIcon.svg"}
      />
      <h3>Status</h3>
      <div
        className="status_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
          <p>Monitor Webhooks</p>
        </div>
      </div>
      <div
        className="status_block_item"
        style={{
          borderBottom: "1px solid #8D99A3",
          paddingBottom: "35px",
        }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={"applyPunishment"} />
          <div className="white_list_block_item_title_block">
            <p className="white_list_block_item_title">
              Apply Global Punishment
            </p>
            <TipsTamplate
              title={"Global Punishment"}
              label={"Safe"}
              text={
                "<p>Punishment represents what Themis does once this flag is triggered and the total amount of flags accumulated by the member surpasses the limit.</p>"
              }
              textSecond={
                "<p>Punishment type and sensitivity can be override using Advanced Settings</p>"
              }
            />
          </div>
        </div>
        <ChooseActionTamplate
          keyName={"punishment"}
          currentAction={currentAction}
          setCurrentAction={setCurrentAction}
          actionArr={statusActions}
        />
      </div>
      <div className="status_block_item">
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnRuleset} setIsOn={setIsOnRuleset} keyName={"useRuleset"} />
          <p>Use Rulesets</p>
        </div>
        <div className="input_checkbox_user_wrap">
          <InputCheckBoxUser item={repeated} setCheckCurrent={setRepeated} />
          <InputCheckBoxUser item={zalgo} setCheckCurrent={setZalgo} />
          <InputCheckBoxUser item={external} setCheckCurrent={setExternal} />
          <InputCheckBoxUser item={invites} setCheckCurrent={setInvites} />
          <InputCheckBoxUser item={files} setCheckCurrent={setFiles} />
          
        </div>
      </div>
    </div>
  );
};

export default StatusTamplate;
